import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/do";
import { SpinnerService } from "./spinner.service";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { GlobalService } from "./global.service";
import { tap } from "rxjs/operators";
import { catchError } from "rxjs/operators/catchError";
import { _throw as throwError } from "rxjs/observable/throw";

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
  private totalRequests = 0;
  constructor(
    private spinnerService: SpinnerService,
    private toastrService: ToastrService,
    private router: Router,
    private globalService: GlobalService
  ) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.totalRequests++;
    this.spinnerService.displayLoader(true);
    if (localStorage.getItem("token")) {
      req = req.clone({
        setHeaders: {
          Authorization: localStorage.getItem("token"),
        },
      });
    }
    if (req.body) {
      if (localStorage.getItem("organisation_id")) {
        req.body["organisation_id"] = localStorage.getItem("organisation_id");
      }
      if (localStorage.getItem("eventId")) {
        req.body["event_id"] = localStorage.getItem("eventId");
      }
    }
    //     return next.handle(req).do((event: HttpEvent<any>) => {
    //       console.log("blaaaaaaaaa");
    //       this.spinnerService.displayLoader(false);
    //       if (event instanceof HttpResponse) {
    //         // do stuff with response if you want
    //         console.log("IOIOIOIOIOIOIOIO",event)
    //       }
    //     }, (err: any) => {
    //       if (err instanceof HttpErrorResponse) {
    //         if (err.status === 401) {
    //         console.log("555555",err);
    //         if (err.error == "Unauthorized") {
    //           this.toastrService.clear();
    //           this.spinnerService.displayLoader(false);
    //           this.toastrService.error("Signing Out", 'Session Timed Out', { timeOut: 8000 });
    //           localStorage.removeItem('token');
    //           this.router.navigate(['/authentication/sign-in']);
    //       }

    //           // redirect to the login route
    //           // or show a modal
    //         }
    //       }
    //     });
    // }
    return next.handle(req).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this.decreaseRequests();
          }
          // return event;
        },
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              //   if (err.error == "Unauthorized") {
              //     this.toastrService.clear();
              //     this.spinnerService.displayLoader(false);
              //     this.toastrService.error("Signing Out", 'Session Timed Out', { timeOut: 8000 });
              //     localStorage.removeItem('token');
              //     this.router.navigate(['/authentication/sign-in']);
              // }
            }
          }
        }
      ),
      catchError((response) => {
        if (response instanceof HttpErrorResponse) {
          this.decreaseRequests();
        }
        return throwError(response);
      })
    );
  }

  private decreaseRequests() {
    this.totalRequests--;
    if (this.totalRequests === 0) {
      this.spinnerService.displayLoader(false);
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/neenu.korula/AA/eventorg-web/src/app/services/auth-interceptor.service.ts